import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BusinessManagerService } from '../user/business-manager.service';
import { AuthService } from '../../auth/auth/auth.service';
import { FlightbridgeService } from '../services/flightbridge.service';
import { environment } from '../../../environments/environment';
import { formatDate } from '@angular/common';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
var FlightbridgeRightRailComponent = /** @class */ (function () {
    function FlightbridgeRightRailComponent(_businessManagerService, _auth, _flightbridgeService, _analyticsService) {
        this._businessManagerService = _businessManagerService;
        this._auth = _auth;
        this._flightbridgeService = _flightbridgeService;
        this._analyticsService = _analyticsService;
        this.isLoggedIn = false;
        this.isMember = false;
    }
    FlightbridgeRightRailComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this._auth.authenticated && this._auth.endUser)) return [3 /*break*/, 2];
                        this.isLoggedIn = true;
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isMember()];
                    case 1:
                        _a.isMember = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    FlightbridgeRightRailComponent.prototype.navigateToFlightBridge = function (pageType) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ssoRetval, firstDate, firstDateString, nextDate, nextDateString, URL;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._flightbridgeService.postFlightBridgeSSOInitial()];
                    case 1:
                        ssoRetval = _a.sent();
                        firstDate = new Date();
                        firstDate.setDate(firstDate.getDate() + 1);
                        firstDateString = formatDate(firstDate, 'yyyy-MM-dd', 'en-US');
                        nextDate = new Date();
                        nextDate.setDate(nextDate.getDate() + 3);
                        nextDateString = formatDate(nextDate, 'yyyy-MM-dd', 'en-US');
                        URL = '';
                        if (pageType === 'hotel') {
                            this._analyticsService.trackEvent('airport_flightbridge_hotel', '', '');
                            if (this.airportIdent) {
                                // tslint:disable-next-line:max-line-length
                                URL = environment.flightBridgeHotelUrl + "&UserAuthenticationToken=" + ssoRetval.token + "&AirportCode=" + this.airportIdent + "&CheckInDate=" + firstDateString + "&CheckOutDate=" + nextDateString;
                                this._analyticsService.trackEvent('airport_flightbridge_hotel-specific', this.airportIdent, this.airportIdent);
                            }
                            else {
                                // tslint:disable-next-line:max-line-length
                                URL = environment.flightBridgeAnywhereHotelUrl + "&UserAuthenticationToken=" + ssoRetval.token + "&CheckInDate=" + firstDateString + "&CheckOutDate=" + nextDateString;
                            }
                        }
                        else if (pageType === 'rentalcar') {
                            this._analyticsService.trackEvent('airport_flightbridge_rentalcar', '', '');
                            if (this.airportIdent) {
                                // tslint:disable-next-line:max-line-length
                                URL = environment.flightBridgeRentalCarUrl + "&UserAuthenticationToken=" + ssoRetval.token + "&AirportCode=" + this.airportIdent + "&CheckInDate=" + firstDateString + "&CheckOutDate=" + nextDateString;
                                this._analyticsService.trackEvent('airport_flightbridge_rentalcar-specific', this.airportIdent, this.airportIdent);
                            }
                            else {
                                // tslint:disable-next-line:max-line-length
                                URL = environment.flightBridgeAnywhereRentalCarUrl + "&UserAuthenticationToken=" + ssoRetval.token + "&CheckInDate=" + firstDateString + "&CheckOutDate=" + nextDateString;
                            }
                        }
                        else {
                            // tslint:disable-next-line:max-line-length
                            URL = environment.flightBridgeAirlineUrl + "&UserAuthenticationToken=" + ssoRetval.token + "&CheckInDate=" + firstDateString + "&CheckOutDate=" + nextDateString;
                            this._analyticsService.trackEvent('airport_flightbridge_airline', '', '');
                        }
                        window.open(URL);
                        return [2 /*return*/];
                }
            });
        });
    };
    FlightbridgeRightRailComponent.prototype.navigateToJoinAOPA = function () {
        window.open('https://www.aopa.org/account/multipagejoin');
    };
    FlightbridgeRightRailComponent.prototype.navigateToLogin = function () {
        window.open('https://www.aopa.org/login');
    };
    return FlightbridgeRightRailComponent;
}());
export { FlightbridgeRightRailComponent };
